// extracted by mini-css-extract-plugin
export default {"containerWrapperPlaceholder":"VideoResponseField__containerWrapperPlaceholder___cU6gb","label":"VideoResponseField__label___fB6OQ"};